<template>
  <ResultsMapBanner v-if="visible" :image-url="settings.mapBannerImageUrl" @select-map="handleSelectMap" />
</template>

<script setup>
import { computed, ref, watchEffect } from "vue";
import { useHostElement } from "#ce/composables/useHostElement";
import { whenI18nReady } from "#ce/components/SpFinder/i18n";
import { useFinderResults } from "#ce/components/SpFinder/composables/useFinderResults";
import ResultsMapBanner from "./components/ResultsMapBanner.ce.vue";

const catalogsReady = ref(false);

function markCatalogsReady() {
  catalogsReady.value = true;
}

whenI18nReady.then(markCatalogsReady);

const host = useHostElement();
const { settings, commands } = useFinderResults();

const visible = computed(() => catalogsReady.value && Boolean(settings.value) && !settings.value.hideMapView);

function reflectVisibility() {
  host?.toggleAttribute("hidden", !visible.value);
}

watchEffect(reflectVisibility);

function handleSelectMap() {
  commands.selectView("map");
}
</script>

<style lang="scss">
@use "@assets/mixins/breakpoint" as *;

:host {
  display: none;
  padding-block: var(
    --sp-comp-finder-results-map-banner-padding-block,
    var(--sp-comp-finder-result-padding-block, var(--sp-ref-scale-48))
  );
}

@include sp-breakpoint(lg) {
  :host(:not([hidden])) {
    display: block;
  }
}
</style>
